/* i18n */
if(typeof window!=="undefined"&&typeof window.TR==="undefined"){window.TR=function(k,v){if(window.GS&&GS.t)return GS.t(k,v);if(window.GSUX_LANG&&window.GSUX_LANG[k]!=null)return window.GSUX_LANG[k];return k;};}
var TR=window.TR;
/*! GhostStat live watch — a floating indicator, on every page.
 *
 * The watch list is only useful if it reaches you while you are looking at something else. This
 * rides along on every app page: a small pill bottom-right that stays quiet until someone is on a
 * watched page, then carries a count and a red dot when there is activity you have not seen.
 *
 * It shows PEOPLE, not pages. "Three visitors on /for-sale" tells you nothing you can act on;
 * "this visitor has read four pages, scrolled 80% and their intent is climbing" does. Each visitor
 * is tracked individually, with what changed since you last looked.
 */
(function () {
  "use strict";
  if (!window.GS) return;

  var POLL_MS   = 15000;
  /* ack: session_id -> the activity fingerprint you have actually LOOKED AT, meaning the panel was
     open while that visitor was in it. Focusing the tab is not acknowledgement — clearing on focus
     meant the count vanished in the instant you switched over to read it, which is precisely the
     moment it needed to still be there. */
  var ack       = {};
  var unseen    = 0;
  var NEW_ARRIVALS = 0;
  var DATA      = null;
  var timer     = null;
  var built     = false;
  var offEl     = null;
  var folEl     = null;     // the "Follow live" panel
  var FOLLOW    = 0;        // session id being followed, 0 when the panel is closed
  var folTimer  = null;
  var folSteps  = 0;        // steps already drawn, so only a NEW page animates in
  var FOLLOW_MS = 5000;

  /* ── Alerts (Page Watch 1.1.0) ───────────────────────────────────────────────
     A visitor who lands on a watch with "Alert me" on gets one pop-up, on whatever GhostStat page is
     open. "Already shown" survives moving between pages (sessionStorage, this tab only, holding
     session numbers and nothing else); without it every page load would announce the same people
     again. The first poll in a fresh tab only takes note of who is already there: they were there
     before you looked, so they are not news, and the pill already counts them. */
  function sget(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
  function sset(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }
  function lget(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lset(k, v) { try { if (v === null) window.localStorage.removeItem(k); else window.localStorage.setItem(k, v); } catch (e) {} }
  var TKEY = null, toasted = {}, seeded = false;
  var muted = lget("gs-lw-mute") === "1";
  var missed = +(sget("gs-lw-missed") || 0) || 0;
  function loadToasted() {
    if (TKEY) return;
    TKEY = "gs-lw-toasted:" + (GS.site || "");
    var raw = sget(TKEY);
    if (raw !== null) {
      seeded = true;
      try { (JSON.parse(raw) || []).forEach(function (id) { toasted[id] = 1; }); } catch (e) {}
    }
  }
  function saveToasted() {
    var ids = Object.keys(toasted);
    if (ids.length > 300) ids = ids.slice(-300);
    sset(TKEY, JSON.stringify(ids));
  }

  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) {
    return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function nf(n) { n = +n || 0; return n >= 1e3 ? (n / 1e3).toFixed(1) + "k" : String(n); }
  function tone(i) { return i == null ? "#8C95A1" : i >= 65 ? "#1FA463" : i >= 40 ? "#D97706" : "#DC2626"; }
  function ago(ts) {
    if (!ts) return "";
    var d = new Date(String(ts).replace(" ", "T"));
    var s = Math.max(0, Math.round((Date.now() - d.getTime()) / 1000));
    return s < 60 ? s + "s ago" : s < 3600 ? Math.round(s / 60) + "m ago" : Math.round(s / 3600) + "h ago";
  }

  /* What "new activity" means for one visitor: a different page, more pages, or more scroll.
     Without this the dot would light up on every poll and stop meaning anything. */
  function fingerprint(v) {
    /* last_seen is deliberately excluded: it ticks on every heartbeat, so including it would mark
       every visitor as "new activity" on every poll and the red dot would mean nothing. What counts
       as activity is a page change, another page read, or more of this page seen. */
    return [v.page || "", v.pages || 0, v.scroll == null ? "" : v.scroll,
            (v.journey || []).length].join("|");
  }

  /* ── Reaching you on another tab ────────────────────────────────────────────
     Two signals, because they fail in different situations. The title carries a count, which is
     what you read when GhostStat is one of three tabs. The favicon carries a red badge, which is
     the only thing visible when it is one of fifteen and the title has been truncated to nothing.
     Both stop the moment the tab is looked at — an indicator that keeps shouting after you have
     answered it teaches you to ignore it. */
  var TITLE0 = null, ICON0 = null, flipTimer = null, flipped = false;
  var reduceMotion = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;

  function iconLink() {
    var l = document.querySelector('link[rel="icon"]');
    if (!l) { l = document.createElement("link"); l.rel = "icon"; document.head.appendChild(l); }
    return l;
  }

  /* The favicon is an SVG, so the badge is drawn as SVG too — no canvas, no CORS, and it stays
     crisp on a high-density screen. */
  function badgedIcon(n) {
    var label = n > 9 ? "9+" : String(n);
    var svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">'
      + '<circle cx="32" cy="32" r="26" fill="#1FA463"/>'
      + '<circle cx="23" cy="28" r="4" fill="#fff"/><circle cx="41" cy="28" r="4" fill="#fff"/>'
      + '<path d="M20 42c4 5 20 5 24 0" stroke="#fff" stroke-width="4" fill="none" stroke-linecap="round"/>'
      + '<circle cx="50" cy="14" r="13" fill="#DC2626" stroke="#fff" stroke-width="3"/>'
      + '<text x="50" y="20" font-family="system-ui,sans-serif" font-size="' + (label.length > 1 ? 14 : 17)
      + '" font-weight="700" fill="#fff" text-anchor="middle">' + label + "</text></svg>";
    return "data:image/svg+xml," + encodeURIComponent(svg);
  }

  /* Stop the alternation but keep whatever count is showing: blinking at someone who is already
     looking at the tab is noise, the number is not. */
  function stopBlink() {
    if (flipTimer) { clearInterval(flipTimer); flipTimer = null; }
    flipped = false;
    if (TITLE0 !== null && unseen > 0) document.title = "(" + unseen + ") " + TITLE0;
  }

  function notifyStop() {
    stopBlink();
    if (TITLE0 !== null) { document.title = TITLE0; TITLE0 = null; }
    if (ICON0 !== null) { iconLink().href = ICON0; ICON0 = null; }
  }

  function notifyStart(n) {
    if (n <= 0) { notifyStop(); return; }
    if (TITLE0 === null) TITLE0 = document.title;
    if (ICON0 === null) ICON0 = iconLink().getAttribute("href") || "";
    iconLink().href = badgedIcon(n);

    var withCount = "(" + n + ") " + TITLE0;
    if (reduceMotion) { document.title = withCount; return; }   // steady, not blinking
    document.title = withCount;
    if (flipTimer) clearInterval(flipTimer);
    flipTimer = setInterval(function () {
      flipped = !flipped;
      document.title = flipped
        ? "\u25CF " + n + " visitor" + (n === 1 ? "" : "s") + " active"
        : withCount;
    }, 1400);
  }

  /* Only shout when you are somewhere else. On this tab the pill is already in view. */
  /* The count shows whenever something is unread, on any tab. The blinking only happens while you
     are elsewhere, because that is the only time it has a job to do. */
  function notify() {
    if (unseen <= 0) { notifyStop(); return; }
    notifyStart(unseen);
    if (!document.hidden) stopBlink();
  }

  function build() {
    if (built) return;
    built = true;

    var pill = document.createElement("button");
    pill.type = "button";
    pill.id = "gs-lw-pill";
    pill.className = "gs-lw-pill";
    pill.hidden = true;
    pill.setAttribute("aria-label", TR('js.live_visitors_on_watched_pages'));
    pill.innerHTML = '<i class="bi bi-binoculars" aria-hidden="true"></i>'
      + '<span class="gs-lw-n" data-lw="count">0</span>'
      + '<span class="gs-lw-dot" data-lw="dot" hidden></span>';
    document.body.appendChild(pill);

    var oc = document.createElement("div");
    oc.className = "offcanvas offcanvas-end gs-lw-oc";
    oc.tabIndex = -1;
    oc.id = "gsLiveWatchOc";
    oc.setAttribute("aria-labelledby", "gsLiveWatchLabel");
    oc.innerHTML =
      '<div class="offcanvas-header"><div>'
      + '<h5 class="offcanvas-title" id="gsLiveWatchLabel">'+TR('js.live_on_watched_pages')+'</h5>'
      + '<div class="gs-lw-sub" data-lw="sub"></div></div>'
      + '<button type="button" class="gs-lw-mute" data-lw="mute" aria-pressed="false"></button>'
      + '<button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="'+TR('js.close')+'"></button></div>'
      + '<div class="offcanvas-body" data-lw="body"></div>';
    document.body.appendChild(oc);
    offEl = oc;

    pill.addEventListener("click", open);
    oc.addEventListener("click", function (e) {
      var f = e.target.closest && e.target.closest("[data-lw-follow]");
      if (f) { follow(+f.getAttribute("data-lw-follow")); return; }
      if (e.target.closest && e.target.closest('[data-lw="mute"]')) setMuted(!muted);
    });

    var tw = document.createElement("div");
    tw.id = "gs-lw-toasts";
    tw.className = "gs-lw-toasts";
    tw.setAttribute("aria-live", "polite");
    document.body.appendChild(tw);

    var fo = document.createElement("div");
    fo.className = "offcanvas offcanvas-end gs-lw-oc gs-lw-fol";
    fo.tabIndex = -1;
    fo.id = "gsLwFollowOc";
    fo.setAttribute("aria-labelledby", "gsLwFollowLabel");
    fo.innerHTML =
      '<div class="offcanvas-header"><div class="gs-lw-min">'
      + '<h5 class="offcanvas-title" id="gsLwFollowLabel">' + esc(TR('js.lw.following')) + '</h5>'
      + '<div class="gs-lw-sub" data-lwf="sub"></div></div>'
      + '<button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="' + esc(TR('js.close')) + '"></button></div>'
      + '<div class="offcanvas-body" data-lwf="body"></div>'
      + '<div class="gs-lw-fol-f" data-lwf="foot"></div>';
    document.body.appendChild(fo);
    folEl = fo;
    fo.addEventListener("hidden.bs.offcanvas", function () {
      FOLLOW = 0; folSteps = 0;
      if (folTimer) { clearInterval(folTimer); folTimer = null; }
    });
    paintMute();
    oc.addEventListener("shown.bs.offcanvas", function () {
      /* Opening is what "seen" means — clear the dot and record what each visitor looked like. */
      unseen = 0; notifyStop(); paintPill();
      (DATA && DATA.visitors || []).forEach(function (v) { ack[v.session_id] = fingerprint(v); });
      render();
    });
  }

  function q(k) { return document.querySelector('[data-lw="' + k + '"]'); }

  function paintPill() {
    var pill = document.getElementById("gs-lw-pill");
    if (!pill) return;
    var n = (DATA && DATA.visitors) ? DATA.visitors.length : 0;
    pill.hidden = n === 0 && unseen === 0;
    var c = q("count"); if (c) c.textContent = n;
    var d = q("dot");
    if (d) { d.hidden = unseen === 0; d.textContent = unseen > 9 ? "9+" : String(unseen); }
    pill.classList.toggle("has-new", unseen > 0);
    notify();
  }

  /* One card per VISITOR, not per page: the question is what this person is doing. */
  function dur(sec) {
    sec = Math.max(0, +sec || 0);
    if (sec < 60) return sec + "s";
    var m = Math.floor(sec / 60), r = sec % 60;
    return m < 60 ? m + "m" + (r ? " " + r + "s" : "") : Math.floor(m / 60) + "h " + (m % 60) + "m";
  }

  /* The page sequence, newest last, with how far they got on each. The final row is where they are
     now; the ones above are what they did before, including the ones they abandoned. */
  function journey(v) {
    var j = v.journey || [];
    if (!j.length) return "";
    var jc = [];
    j.forEach(function (step) { var l = jc[jc.length - 1];
      if (l && l.path === step.path) { l.repeat = (l.repeat || 1) + 1; if (step.scroll != null) l.scroll = step.scroll; l.dwell_s = (l.dwell_s || 0) + (step.dwell_s || 0); }
      else jc.push(Object.assign({ repeat: 1 }, step)); });
    return '<div class="gs-lw-j"><div class="gs-lw-j-h">'+TR('js.their_path_this_visit')+'</div>'
      + jc.map(function (step, i) {
          var last = i === jc.length - 1;
          var left = !last && step.scroll != null
            ? "left after " + step.scroll + "%"
            : (step.scroll != null ? step.scroll + "% scrolled" : "");
          return '<div class="gs-lw-j-s' + (last ? " now" : "") + '">'
            + '<span class="gs-lw-j-p">' + esc(step.path) + (step.repeat > 1 ? ' \u00d7' + step.repeat : '') + "</span>"
            + '<span class="gs-lw-j-m">' + esc([left, step.dwell_s != null ? dur(step.dwell_s) : ""]
                .filter(Boolean).join(" \u00b7 ")) + "</span>"
            + (last ? '<span class="gs-lw-j-tag">here now</span>' : "") + "</div>";
        }).join("")
      + "</div>";
  }

  function card(v) {
    var isNew = ack[v.session_id] !== undefined && ack[v.session_id] !== fingerprint(v);
    var firstTime = ack[v.session_id] === undefined;
    var bits = [];
    if (v.intent != null)   bits.push("intent " + v.intent);
    if (v.friction != null) bits.push("friction " + v.friction);
    if (v.attention != null) bits.push("attention " + v.attention);

    var links = [
      ["/visitor-intelligence?session_id=", TR('js.visitor_intelligence'), TR('js.everything_about_this_visitor')],
      ["/session-recordings?session_id=", "Session Recording", TR('js.watch_what_they_did')],
      ["/user-flow?session_id=", TR('js.user_flow'), TR('js.the_path_they_took')],
      ["/identity-graph?session_id=", TR('js.identity_graph'), TR('js.every_signal_fused')],
      ["/page-watch?session_id=", TR('js.page_watch'), TR('js.back_to_the_watch_list')]
    ].map(function (l) {
      return '<a class="gs-lw-link" href="' + l[0] + encodeURIComponent(v.session_id) + '" title="' + esc(l[2]) + '">'
           + esc(l[1]) + "</a>";
    }).join("");

    return '<article class="gs-lw-card live' + (isNew || firstTime ? " fresh" : "") + '">'
      + '<button type="button" class="gs-lw-follow-btn" data-lw-follow="' + esc(v.session_id) + '">'
      + '<i class="bi bi-play-fill" aria-hidden="true"></i> ' + esc(TR('js.lw.follow_live')) + '</button>'
      + '<div class="gs-lw-c-h"><b>' + esc(v.page || "\u2014") + "</b>"
      + '<span class="gs-lw-c-when">active ' + dur(v.idle_s) + " ago</span></div>"

      /* Where they came from and how long they have been here — the two questions you ask first. */
      + '<div class="gs-lw-facts">'
      +   fact("From", v.referrer && v.referrer !== TR('js.direct') ? v.referrer : TR('js.direct'))
      +   fact("On site", dur(v.age_s))
      +   fact(TR('js.pages'), v.pages)
      +   fact(TR('js.scrolled'), v.scroll == null ? "\u2014" : v.scroll + "%")
      + "</div>"

      + '<div class="gs-lw-id" style="background:#fff;border:1px solid #E5E8EF;border-radius:8px;padding:8px 10px;margin:8px 0;font-size:13px;color:#12172A;display:flex;gap:14px;flex-wrap:wrap">'
      +   '<span><i class="bi bi-geo-alt"></i> ' + esc([v.city, v.country].filter(Boolean).join(", ") || "\u2014") + '</span>'
      +   '<span><i class="bi bi-phone"></i> ' + esc(v.device || "\u2014") + '</span>'
      +   (v.browser ? '<span><i class="bi bi-globe2"></i> ' + esc(v.browser) + '</span>' : '')
      + '</div>'
      + ((v.persona || v.journey_stage) ? '<div class="gs-lw-c-meta">'
          + esc([v.persona, v.journey_stage].filter(Boolean).join(" \u00b7 ")) + '</div>' : '')
      + (bits.length ? '<div class="gs-lw-c-sig" style="color:' + tone(v.intent) + '">'
          + esc(bits.join(" \u00b7 ")) + "</div>" : "")
      + journey(v)
      + '<div class="gs-lw-c-why">' + esc(v.why || "") + "</div>"
      + '<div class="gs-lw-links">' + links + "</div>"
      + "</article>";
  }

  function fact(k, v) {
    return '<div class="gs-lw-fact"><span>' + k + "</span><b>" + esc(v) + "</b></div>";
  }

  function render() {
    var body = q("body"); if (!body) return;
    var vs = (DATA && DATA.visitors) || [];
    var sub = q("sub");
    if (sub) sub.textContent = vs.length
      ? vs.length + " visitor" + (vs.length === 1 ? "" : "s") + " on a watched page or source"
      : TR('js.nobody_on_a_watched_page_right_now');
    body.innerHTML = vs.length
      ? vs.map(card).join("")
      : '<p class="gs-lw-empty">Nobody is on a watched page right now. This lists only people who are '
        + 'here at this moment \u2014 once they leave, their visit moves to '
        + '<a href="/page-watch">'+TR('js.page_watch')+'</a>.</p>';
  }

  /* Who should pop up: on site now, on a watch with "Alert me" on, and not shown before. */
  function alerts(vs) {
    loadToasted();
    var fresh = vs.filter(function (v) { return v.is_live && v.alert && !toasted[v.session_id]; });
    vs.forEach(function (v) { if (v.is_live) toasted[v.session_id] = 1; });
    if (!seeded) { seeded = true; saveToasted(); return; }
    if (fresh.length) saveToasted();
    fresh.forEach(function (v) {
      if (muted) { missed++; sset("gs-lw-missed", String(missed)); }
      else toast(v);
    });
    if (fresh.length && muted) paintMute();
  }

  function flag(cc) {
    cc = String(cc || "").toUpperCase();
    if (!/^[A-Z]{2}$/.test(cc)) return "";
    return String.fromCodePoint(0x1F1E6 + cc.charCodeAt(0) - 65, 0x1F1E6 + cc.charCodeAt(1) - 65);
  }
  var DN = null;
  function country(cc) {
    if (!cc) return "";
    try {
      if (!DN && window.Intl && Intl.DisplayNames)
        DN = new Intl.DisplayNames([document.documentElement.lang || "en"], { type: "region" });
      return DN ? (DN.of(String(cc).toUpperCase()) || cc) : cc;
    } catch (e) { return cc; }
  }
  function cap(s) { s = String(s || ""); return s.charAt(0).toUpperCase() + s.slice(1); }
  function major(v) { return v ? String(v).split(".")[0] : ""; }
  function devLabel(v) { return v.device_model || cap(v.device) || ""; }

  function toast(v) {
    var host = document.getElementById("gs-lw-toasts"); if (!host) return;
    while (host.children.length >= 3) host.removeChild(host.firstChild);
    var src = v.referrer && v.referrer !== "Direct" ? String(v.referrer).replace(/^www\./, "") : "";
    var t = document.createElement("div");
    t.className = "gs-lw-toast";
    t.setAttribute("role", "status");
    var place = [v.city, country(v.country)].filter(Boolean).join(", ");
    t.innerHTML =
      '<div class="gs-lw-t-h"><span class="gs-lw-live" aria-hidden="true"></span>'
      + esc(TR('js.page_watch')) + ' \u00b7 ' + esc((v.hits || []).join(", "))
      + '<button type="button" class="gs-lw-t-x" data-t="close" aria-label="' + esc(TR('js.close')) + '">\u00d7</button></div>'
      + '<div class="gs-lw-t-m">' + (src
          ? TR('js.lw.toast_from', { src: '<b>' + esc(src) + '</b>', page: '<b>' + esc(v.page || "/") + '</b>' })
          : TR('js.lw.toast_direct', { page: '<b>' + esc(v.page || "/") + '</b>' })) + '</div>'
      + '<div class="gs-lw-t-meta">' + esc([flag(v.country) + (place ? " " + place : ""),
          [devLabel(v), v.browser].filter(Boolean).join(" \u00b7 ")].filter(function (x) { return x && x.trim(); }).join(" \u00b7 ")) + '</div>'
      + '<div class="gs-lw-t-acts"><button type="button" class="gs-lw-btn pri" data-t="follow">'
      + '<i class="bi bi-play-fill" aria-hidden="true"></i> ' + esc(TR('js.lw.follow_live')) + '</button>'
      + '<button type="button" class="gs-lw-btn" data-t="close">' + esc(TR('js.lw.dismiss')) + '</button></div>';
    host.appendChild(t);
    var timer = setTimeout(function () { closeToast(t); }, 12000);
    t.addEventListener("mouseenter", function () { clearTimeout(timer); });
    t.addEventListener("mouseleave", function () { clearTimeout(timer); timer = setTimeout(function () { closeToast(t); }, 6000); });
    t.addEventListener("focusin", function () { clearTimeout(timer); });
    t.addEventListener("click", function (e) {
      var b = e.target.closest && e.target.closest("[data-t]"); if (!b) return;
      clearTimeout(timer); closeToast(t);
      if (b.getAttribute("data-t") === "follow") follow(v.session_id);
    });
  }
  function closeToast(t) {
    if (!t.parentNode || t.classList.contains("leave")) return;
    t.classList.add("leave");
    setTimeout(function () { if (t.parentNode) t.parentNode.removeChild(t); }, reduceMotion ? 0 : 220);
  }

  function setMuted(on) {
    muted = !!on;
    lset("gs-lw-mute", muted ? "1" : null);
    if (!muted) { missed = 0; sset("gs-lw-missed", "0"); }
    paintMute();
  }
  function paintMute() {
    var b = offEl && offEl.querySelector('[data-lw="mute"]');
    if (b) {
      b.setAttribute("aria-pressed", muted ? "true" : "false");
      b.classList.toggle("is-muted", muted);
      b.title = muted ? TR('js.lw.unmute_tip') : TR('js.lw.mute_tip');
      b.innerHTML = '<i class="bi ' + (muted ? "bi-bell-slash" : "bi-bell") + '" aria-hidden="true"></i> '
        + esc(muted ? TR('js.lw.muted') : TR('js.lw.alerts_on'))
        + (muted && missed ? '<span class="gs-lw-missed">' + (missed > 99 ? "99+" : missed) + '</span>' : "");
    }
    var p = document.getElementById("gs-lw-pill");
    if (p) p.classList.toggle("is-muted", muted);
  }

  /* ── Follow live ─────────────────────────────────────────────────────────── */
  function follow(sid) {
    sid = +sid; if (!sid || !folEl || !window.bootstrap || !bootstrap.Offcanvas) return;
    if (offEl && offEl.classList.contains("show")) bootstrap.Offcanvas.getOrCreateInstance(offEl).hide();
    var pw = document.getElementById("pwVisitorOc");
    if (pw && pw.classList.contains("show")) bootstrap.Offcanvas.getOrCreateInstance(pw).hide();
    FOLLOW = sid; folSteps = 0;
    var b = folEl.querySelector('[data-lwf="body"]');
    if (b) b.innerHTML = '<p class="gs-lw-empty">' + esc(TR('js.lw.loading')) + '</p>';
    var sub = folEl.querySelector('[data-lwf="sub"]'); if (sub) sub.textContent = "";
    bootstrap.Offcanvas.getOrCreateInstance(folEl).show();
    folPoll();
    if (folTimer) clearInterval(folTimer);
    folTimer = setInterval(function () { if (!document.hidden) folPoll(); }, FOLLOW_MS);
  }
  function folPoll() {
    var sid = FOLLOW; if (!sid || !GS.api || !GS.site) return;
    GS.api("/plugin/page-watch/visitor?site=" + encodeURIComponent(GS.site) + "&sid=" + encodeURIComponent(sid))
      .then(function (r) {
        if (FOLLOW !== sid) return;
        var d = (r && r.data) ? r.data : r;
        renderFollow(d);
        if (d && d.state === "left" && folTimer) { clearInterval(folTimer); folTimer = null; }  // nothing more will happen
      })
      .catch(function () {
        var b = folEl && folEl.querySelector('[data-lwf="body"]');
        if (b && !folSteps) b.innerHTML = '<p class="gs-lw-empty">' + esc(TR('js.lw.load_failed')) + '</p>';
      });
  }

  function netLabel(t) {
    var k = 'js.lw.net.' + String(t || "");
    var s = t ? TR(k) : "";
    return s && s !== k ? s : (t || "");
  }
  function dateOf(ts) {
    var d = new Date(String(ts).replace(" ", "T") + "Z");
    if (isNaN(d.getTime())) return "";
    try { return d.toLocaleDateString(document.documentElement.lang || undefined, { day: "numeric", month: "short", year: "numeric" }); }
    catch (e) { return d.toDateString(); }
  }

  function renderFollow(d) {
    var body = folEl && folEl.querySelector('[data-lwf="body"]'); if (!body) return;
    var sub  = folEl.querySelector('[data-lwf="sub"]');
    var foot = folEl.querySelector('[data-lwf="foot"]');
    if (!d || d.error) {
      body.innerHTML = '<p class="gs-lw-empty">' + esc(TR('js.lw.not_found')) + '</p>';
      if (foot) foot.innerHTML = "";
      return;
    }
    var color = d.color || "#94A3B8";
    var src = String(d.referrer || "").replace(/^www\./, "");   // shown as Referrers Intelligence shows it
    var dot = '<span class="gs-lw-cdot" style="background:' + esc(color) + '"></span>';
    if (sub) sub.innerHTML = dot + esc(src ? TR('js.lw.from', { src: src }) : TR('js.lw.direct_visit'))
      + ' \u00b7 ' + esc(TR('js.lw.session', { id: d.session_id }));

    var st = d.state === "left"
      ? '<div class="gs-lw-state gone"><span class="gs-lw-live"></span>' + esc(TR('js.lw.left_ago', { t: dur(d.left_ago_s) })) + '</div>'
      : d.state === "idle"
        ? '<div class="gs-lw-state idle"><span class="gs-lw-live"></span>' + esc(TR('js.lw.idle', { t: dur(d.idle_s) })) + '</div>'
        : '<div class="gs-lw-state"><span class="gs-lw-live"></span>' + esc(TR('js.lw.active')) + '</div>';

    /* Known bot: name + verified. With a bot score (migration 112): the score and its reasons.
       Without one: hosting address = unsure, anything else = no bot signs. */
    var sc = d.bot_score, sg = (d.bot_signals || []).map(function (c) { var k = "tq.sig." + c, s = TR(k); return s === k ? c : s; });
    var vd;
    if (d.verdict === "bot")
      vd = '<span class="gs-lw-vd bot"><i class="bi bi-robot" aria-hidden="true"></i> ' + esc(TR('js.lw.vd_bot')) + '</span>'
        + '<small>' + esc([d.bot_name, d.bot_verified ? TR('js.lw.vd_verified') : ""].filter(Boolean).join(" \u00b7 ")) + '</small>';
    else if (sc != null)
      vd = '<span class="gs-lw-vd ' + (d.verdict === "likely" ? "bot" : d.verdict) + '"><i class="bi ' + (d.verdict === "likely" ? "bi-robot" : d.verdict === "unsure" ? "bi-question-circle" : "bi-person-check") + '" aria-hidden="true"></i> '
        + esc(TR(d.verdict === "likely" ? 'js.lw.vd_likely' : d.verdict === "unsure" ? 'js.lw.vd_unsure_s' : 'js.lw.vd_person')) + ' \u00b7 ' + sc + '</span>'
        + '<small>' + esc(sg.length ? sg.join(" \u00b7 ") : TR('js.lw.vd_no_signals')) + '</small>';
    else if (d.verdict === "unsure")
      vd = '<span class="gs-lw-vd unsure"><i class="bi bi-question-circle" aria-hidden="true"></i> ' + esc(TR('js.lw.vd_unsure')) + '</span>'
        + '<small>' + esc(TR('js.lw.vd_unsure_why', { n: d.bot_name || d.provider || "" })) + '</small>';
    else
      vd = '<span class="gs-lw-vd clean"><i class="bi bi-person-check" aria-hidden="true"></i> ' + esc(TR('js.lw.vd_clean')) + '</span>'
        + '<small>' + esc(TR('js.lw.vd_clean_why')) + '</small>';
    var verdict = '<div class="gs-lw-vdrow">' + vd + '</div>';

    var facts = '<div class="gs-lw-ffacts">'
      + ffact(TR('js.pages'), d.pages)
      + ffact(TR('js.lw.on_site'), dur(d.age_s))
      + ffact(TR('js.lw.watches_hit'), (d.hits || []).length) + '</div>';

    var now = "";
    if (d.state !== "left") {
      var sc = d.scroll_now, mx = d.scroll_max;
      now = '<div class="gs-lw-now"><div class="gs-lw-lbl">' + esc(TR('js.lw.now_on')) + '</div>'
        + '<div class="gs-lw-pg">' + esc(d.page || "\u2014") + '</div>'
        + (sc != null
          ? '<div class="gs-lw-scroll"><span class="gs-lw-tr" role="progressbar" aria-label="' + esc(TR('js.scrolled')) + '" aria-valuenow="' + sc + '" aria-valuemin="0" aria-valuemax="100">'
            + '<i style="width:' + sc + '%"></i>' + (mx > sc ? '<em style="left:calc(' + mx + '% - 1px)" title="' + esc(TR('js.lw.furthest_tip')) + '"></em>' : '')
            + '</span><b>' + sc + '%</b>'
            + '<small>' + esc(TR('js.lw.scroll_line', { max: mx, t: dur(d.on_page_s) })) + '</small></div>'
          : '<small class="gs-lw-muted">' + esc(TR('js.lw.no_scroll_yet')) + '</small>')
        + '</div>';
    }

    var loc = [d.city, d.region].filter(Boolean).join(", ");
    var cn = country(d.country);
    var visit = d.visit_n == null ? ["\u2014", TR('js.lw.visit_unknown')]
      : d.visit_n <= 1 ? [TR('js.lw.visit_first'), TR('js.lw.new_visitor')]
      : [TR('js.lw.visit_nth', { n: d.visit_n }), TR('js.lw.first_seen', { d: dateOf(d.first_seen) })];
    var dev = devLabel(d);
    var who = '<div><div class="gs-lw-lbl">' + esc(TR('js.lw.who')) + '</div><div class="gs-lw-who">'
      + wcell(TR('js.lw.location'), (flag(d.country) ? flag(d.country) + " " : "") + (loc || cn || "\u2014"), loc ? cn : "")
      + wcell(TR('js.lw.visit'), visit[0], visit[1])
      + wcell(TR('js.lw.browser'), [d.browser, major(d.browser_version)].filter(Boolean).join(" ") || "\u2014", "")
      + wcell(TR('js.lw.system'), [d.os, d.os_version].filter(Boolean).join(" ") || "\u2014", "")
      + wcell(TR('js.lw.device'), dev || "\u2014", d.screen ? TR('js.lw.screen', { s: String(d.screen).replace("x", " \u00d7 ") }) : "")
      + '<div><span>' + esc(TR('js.lw.network')) + '</span><b>' + esc(d.provider || "\u2014")
          + (d.is_vpn ? '<span class="gs-lw-vpn">' + esc(netLabel(d.provider_type)) + '</span>' : '') + '</b>'
          + (d.provider_type ? '<small>' + esc(netLabel(d.provider_type)) + '</small>' : '') + '</div>'
      + '<div class="wide"><span>' + esc(TR('js.lw.source')) + '</span><b>' + dot
          + esc(src || TR('js.lw.direct_long')) + '</b>'
          + '<small>' + esc([catLabel(d.cat, d.cat_label), d.utm_campaign ? TR('js.lw.campaign', { c: d.utm_campaign }) : (d.utm_source ? "utm " + d.utm_source : "")].filter(Boolean).join(" \u00b7 ")) + '</small></div>'
      + '</div></div>';

    var steps = d.path || [];
    var items = '<li class="src"><span class="gs-lw-pt"></span><span class="gs-lw-pn">'
      + esc(src ? TR('js.lw.came_from', { src: src }) : TR('js.lw.typed')) + '</span><span class="gs-lw-pm"></span></li>';
    steps.forEach(function (p, i) {
      var last = i === steps.length - 1;
      var cls = (last && d.state !== "left" ? "cur" : "") + (i >= folSteps && folSteps > 0 ? " new" : "");
      items += '<li class="' + cls + '"><span class="gs-lw-pt"></span><span class="gs-lw-pn">' + esc(p.path)
        + '<small>' + esc(p.scroll != null ? TR('js.lw.scrolled_pct', { p: p.scroll }) : TR('js.lw.scroll_unknown')) + '</small></span>'
        + '<span class="gs-lw-pm">' + dur(p.for_s) + '</span></li>';
    });
    if (d.state === "left")
      items += '<li class="out"><span class="gs-lw-pt"></span><span class="gs-lw-pn">' + esc(TR('js.lw.left_site'))
        + '<small>' + esc(TR('js.lw.left_line', { n: d.pages, t: dur(d.age_s) })) + '</small></span><span class="gs-lw-pm"></span></li>';
    folSteps = steps.length;

    body.innerHTML = st + verdict + facts + now + who
      + '<div><div class="gs-lw-lbl">' + esc(TR('js.lw.path_live')) + '</div><ol class="gs-lw-path">' + items + '</ol></div>';

    if (foot && !foot.childNodes.length) {
      var q = encodeURIComponent(d.session_id);
      foot.innerHTML = '<a class="gs-lw-btn" href="/visitor-intelligence?session_id=' + q + '">' + esc(TR('js.lw.profile')) + '</a>'
        + '<a class="gs-lw-btn" href="/user-flow?session_id=' + q + '">' + esc(TR('js.lw.in_user_flow')) + '</a>'
        + '<a class="gs-lw-btn" href="/session-recordings?session_id=' + q + '">' + esc(TR('js.lw.recording')) + '</a>';
    }
  }
  function catLabel(c, fallback) {
    var k = 'js.lw.cat.' + String(c || ""), v = c ? TR(k) : "";
    return v && v !== k ? v : (fallback || "");
  }
  function ffact(k, v) { return '<div class="gs-lw-fact"><span>' + esc(k) + '</span><b>' + esc(v) + '</b></div>'; }
  function wcell(k, v, small) {
    return '<div><span>' + esc(k) + '</span><b>' + esc(v) + '</b>' + (small ? '<small>' + esc(small) + '</small>' : '') + '</div>';
  }

  function open() {
    if (!offEl || !window.bootstrap || !bootstrap.Offcanvas) return;
    bootstrap.Offcanvas.getOrCreateInstance(offEl).show();
  }

  function poll() {
    if (!GS.api || !GS.site) return;
    GS.api("/plugin/page-watch/live?site=" + encodeURIComponent(GS.site))
      .then(function (r) {
        var d = (r && r.data) ? r.data : r;
        LAST = d;

        /* Two very different situations that used to be treated the same:
             - the plugin genuinely is not installed or enabled here → go quiet for good
             - anything else unexpected → say so once and keep trying, because a single slow or
               failed request should not disable the indicator for the rest of the page's life. */
        if (d && (d.error === "plugin_not_loaded" || d.error === "plugin_disabled")) {
          say("Page Watch is not enabled for this site, so the live indicator stays hidden.");
          stop(true); return;
        }
        if (!d || !d.watches) {
          say("The live endpoint answered without a watch list. Run GS.liveWatch.debug() to see it.", d);
          quiet(); return;
        }
        if (!d.watches.length) { quiet(); return; }   // nothing watched yet: nothing to show

        /* Flatten to individual visitors, keeping which watch surfaced them so the card can say why. */
        var vs = [], byId = {};
        (d.watches || []).forEach(function (w) {
          /* Live only. Someone who has already left is history, and history belongs on the page,
             not in a floating alert that implies they are here now. */
          var al = w.alert !== false;    // before migration 111 every watch alerts
          (w.live || []).forEach(function (v) {
            /* Known bots (Googlebot, GPTBot, verified crawler addresses …) are not people on your page:
               no pill count, no card, no pop-up. Page Watch itself still lists them, marked. */
            if (v.is_bot || v.verdict === "likely") return;   // likely bots by the bot score too
            if (byId[v.session_id]) {
              byId[v.session_id].why += ", " + (w.kind === "path" ? w.value : "from " + w.value);
              byId[v.session_id].hits.push(w.value);
              if (al) byId[v.session_id].alert = true;
              return;
            }
            var copy = {}; for (var k in v) copy[k] = v[k];
            copy.why = w.kind === "path" ? "On watched page " + w.value : "Arrived from " + w.value;
            copy.hits = [w.value]; copy.alert = al;
            byId[v.session_id] = copy; vs.push(copy);
          });
        });
        vs.sort(function (a, b) { return (b.is_live - a.is_live) || (b.pages - a.pages); });

        var isOpen = offEl && offEl.classList.contains("show");
        var fresh = 0, arrivals = 0;
        vs.forEach(function (v) {
          var fp = fingerprint(v);
          if (ack[v.session_id] === undefined) { fresh++; arrivals++; }
          else if (ack[v.session_id] !== fp) fresh++;
          /* Only an open panel counts as read. */
          if (isOpen) ack[v.session_id] = fp;
        });
        unseen = isOpen ? 0 : fresh;
        NEW_ARRIVALS = arrivals;

        /* Someone who has left stops being owed an acknowledgement; without this, ack grows for the
           life of the page and a returning visitor would never ring again. */
        var liveIds = {};
        vs.forEach(function (v) { liveIds[v.session_id] = 1; });
        Object.keys(ack).forEach(function (id) { if (!liveIds[id]) delete ack[id]; });

        DATA = { visitors: vs };
        alerts(vs);
        paintPill();
        if (isOpen) render();
      })
      .catch(function (e) {
        /* Silent failure is what made this impossible to diagnose. One line, once. */
        say("Live watch request failed: " + ((e && e.message) || e));
        quiet();
      });
  }

  /* Hide the pill but keep polling — the situation may well change on the next tick. */
  function quiet() {
    notifyStop();
    var p = document.getElementById("gs-lw-pill");
    if (p) p.hidden = true;
  }
  /* Give up entirely. Only for "this plugin is not here", which will not change without a reload. */
  function stop(permanent) {
    quiet();
    if (permanent && timer) { clearInterval(timer); timer = null; }
  }

  var SAID = {};
  function say(msg, extra) {
    if (SAID[msg]) return;                 // once per page, not once per poll
    SAID[msg] = true;
    if (window.console) console.info("[GhostStat live watch] " + msg, extra === undefined ? "" : extra);
  }
  function start() {
    build();
    poll();
    if (timer) clearInterval(timer);
    timer = setInterval(function () { if (!document.hidden) poll(); }, POLL_MS);
  }

  /* A debug handle, because "I do not see the toast" has too many possible causes to guess between.
     GS.liveWatch.debug() prints the last response and the state derived from it. */
  var LAST = null;
  GS.liveWatch = {
    debug: function () {
      var out = {
        scriptLoaded: true,
        site: GS.site || null,
        polling: !!timer,
        lastResponse: LAST,
        visitors: (DATA && DATA.visitors) || [],
        unseenCount: unseen,
        newArrivals: NEW_ARRIVALS,
        acknowledged: Object.keys(ack).length,
        alertsMuted: muted,
        missedWhileMuted: missed,
        toastsShown: Object.keys(toasted).length,
        following: FOLLOW || null,
        tabHidden: document.hidden,
        titleNow: document.title,
        pillInDom: !!document.getElementById("gs-lw-pill"),
        pillHidden: (function () { var p = document.getElementById("gs-lw-pill"); return p ? p.hidden : null; })(),
        bootstrapOffcanvas: !!(window.bootstrap && bootstrap.Offcanvas)
      };
      if (window.console) console.log("[GhostStat live watch]", out);
      return out;
    },
    refresh: function () { poll(); },
    open: open,
    follow: follow,
    mute: setMuted
  };

  document.addEventListener("visibilitychange", function () {
    /* Returning to the tab is not an answer — you have not read anything yet. Stop the blinking,
       which would be silly on a tab you are looking at, but keep the count until the panel opens. */
    if (!document.hidden) { stopBlink(); poll(); } else notify();
  });
  if (GS.site) start(); else document.addEventListener("gs:ready", start, { once: true });
})();
